import toArray from 'rc-util/lib/Children/toArray'
import React, { Fragment } from 'react'

export function joinElements(
  children: React.ReactNode[],
  separator: React.ReactNode,
) {
  const childrenArray = toArray(children)
  return childrenArray.map((item, index) => {
    return (
      <Fragment key={item.key || index}>
        {item}
        {index + 1 !== childrenArray.length && separator}
      </Fragment>
    )
  })
}
